"use client"

import { css } from "@emotion/css"

import type { ChapterWithStatus } from "@/generated/course-material-api/types.generated"
import { cardMaxWidth } from "@/shared-module/common/styles/constants"
import { respondToOrLarger } from "@/shared-module/common/styles/respond"
import { omitUndefined } from "@/shared-module/common/utils/nullability"
import { stringToRandomNumber } from "@/shared-module/common/utils/strings"

import ChapterGridCard from "./ChapterGridCard"

const COLORS_ARRAY = [
  "#215887",
  "#1F6964",
  "#822630",
  "#A84835",
  "#6245A9",
  "#313947",
  "#51309F",
  "#065853",
  "#1A2333",
  "#065853",
  "#08457A",
] as const

export interface StyledCardProps {
  chapter: ChapterWithStatus
  courseSlug: string
  now: Date
  organizationSlug: string
  previewable: boolean
  isLocked: boolean
}

/**
 * This component should probably just be merged with `ChapterGridCard` but that is subject for further
 * refactoring.
 */
const StyledCard: React.FC<React.PropsWithChildren<StyledCardProps>> = ({
  chapter,
  courseSlug,
  now,
  organizationSlug,
  previewable,
  isLocked,
}) => {
  const randomNumber = stringToRandomNumber(chapter.id) % COLORS_ARRAY.length
  // randomNumber is a modulo of COLORS_ARRAY.length, so the index is always in range;
  // the fallback keeps the type non-undefined without changing behavior.
  const randomizedColor = COLORS_ARRAY[randomNumber] ?? COLORS_ARRAY[0]
  return (
    <div
      className={css`
        max-width: calc(${cardMaxWidth}rem / 1.1);
        ${respondToOrLarger.md} {
          max-width: ${cardMaxWidth}rem;
        }

        width: 100%;
        /* Basic styles for browsers without css grid support */
        margin: 0 auto;
        margin-bottom: 1rem;
        @supports (display: grid) {
          margin-bottom: 0;
        }
      `}
    >
      <ChapterGridCard
        {...omitUndefined({ backgroundImage: chapter.chapter_image_url })}
        bg={randomizedColor}
        now={now}
        chapter={chapter}
        courseSlug={courseSlug}
        organizationSlug={organizationSlug}
        previewable={previewable}
        isLocked={isLocked}
      />
    </div>
  )
}

export default StyledCard
